export enum Layout {
  TwoByTwo,
  TextLinks,
  ImageLinks,
}
